import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import uuid from 'uuid';
import { EventEmitter } from 'events';
import api from 'core/util/api';
import { getApplicationMetadata, getApplicationName } from '@kentik/ui-shared/query/queryUtils';
import { generateSpoofUrl } from 'app/util/generateSpoofUrl';
import $auth from 'app/stores/$auth';
// shared global sse connection
var eventSource;
var connectionId;
export var Client = /*#__PURE__*/function (_EventEmitter) {
  function Client(options) {
    var _this;
    _classCallCheck(this, Client);
    _this = _callSuper(this, Client);
    _this._channelId = void 0;
    _this._opt = void 0;
    _this._abortController = void 0;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _this.connectHandleFn = function (event) {
      var welcomeMessage = JSON.parse(event.data);
      // check the state of connection before reassign.
      var isReconnect = connectionId !== undefined && connectionId !== welcomeMessage.connectionId;
      connectionId = welcomeMessage.connectionId;
      if (isReconnect) {
        _this.emit('reconnect');
      } else {
        _this.emit('connect');
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _this.channelHandleFn = function (event) {
      var data;
      try {
        data = JSON.parse(event.data);
      } catch (_err) {
        console.warn('error parsing sse json data:', event.data);
        data = event.data;
      }
      if (data && _typeof(data) === 'object' && 'error' in data) {
        setTimeout(function () {
          return _this.onError(data.error);
        }, 10);
      } else {
        setTimeout(function () {
          return _this.onSuccess(data);
        }, 10);
      }
    };
    _this.onSuccess = function (data) {
      if (!_this._opt.onSuccess) {
        _this.emit('onSuccess');
      } else {
        _this._opt.onSuccess(data);
      }
    };
    _this.onReconnect = function () {
      if (_this._opt.onReconnect) {
        _this._opt.onReconnect();
      }
    };
    _this.onError = function (error) {
      if (!_this._opt.onError) {
        _this.emit('onError');
      } else {
        _this._opt.onError(error);
      }
    };
    if (!eventSource) {
      eventSource = new EventSource('/portal_sse/connect');
      eventSource.onopen = function () {};
      eventSource.onerror = function (event) {
        console.info('sse connection error:', event.type);
      };
      eventSource.onmessage = function (event) {
        console.info('Receive unexpected message', event.data);
      };
    }
    _this._opt = options;
    _this._channelId = uuid.v4();
    _this._abortController = new AbortController();
    _this.on('reconnect', _this.onReconnect);
    eventSource.addEventListener('connect', _this.connectHandleFn, {
      signal: _this._abortController.signal
    });
    eventSource.addEventListener(_this.getInChannel(), _this.channelHandleFn, {
      signal: _this._abortController.signal
    });
    return _this;
  }
  _inherits(Client, _EventEmitter);
  return _createClass(Client, [{
    key: "send",
    value: function send(payload) {
      var _this2 = this;
      if (!this.isOpen) {
        console.info("Unable to send data with sse status ".concat(this.readyStateText, ". Retry after connection."));
        if (this.isNew) {
          this.once('connect', function () {
            return _this2.send(payload);
          });
        } else {
          this.once('reconnect', function () {
            return _this2.send(payload);
          });
        }
      } else {
        var newPath = window.location.pathname;
        if (newPath.includes('/export')) {
          newPath = newPath.replace('/export', '');
        }
        payload = Object.assign(payload, {
          requestID: this._channelId,
          responseChannel: this.getInChannel(),
          spoofURL: generateSpoofUrl($auth),
          source: getApplicationName(newPath),
          application_metadata: getApplicationMetadata(payload || payload || {}, newPath)
        });
        api.post(this.getOutChannel(), {
          body: payload
        });
      }
    }
  }, {
    key: "readyStateText",
    get: function get() {
      var _eventSource, _eventSource2;
      switch ((_eventSource = eventSource) === null || _eventSource === void 0 ? void 0 : _eventSource.readyState) {
        case EventSource.CONNECTING:
          return 'CONNECTING (0)';
        case EventSource.OPEN:
          return 'OPEN (1)';
        case EventSource.CLOSED:
          return 'CLOSED (2)';
        default:
          return "UNKNOWN (".concat((_eventSource2 = eventSource) === null || _eventSource2 === void 0 ? void 0 : _eventSource2.readyState, ")");
      }
    }
  }, {
    key: "isOpen",
    get: function get() {
      var _eventSource3;
      return ((_eventSource3 = eventSource) === null || _eventSource3 === void 0 ? void 0 : _eventSource3.readyState) === EventSource.OPEN;
    }
  }, {
    key: "isNew",
    get: function get() {
      return connectionId === undefined;
    }
  }, {
    key: "getInChannel",
    value: function getInChannel() {
      if (this._opt.listenToBroadcast) {
        return this._opt.inType;
      }
      return "".concat(this._opt.inType, "/").concat(this._channelId);
    }
  }, {
    key: "getOutChannel",
    value: function getOutChannel() {
      return "/portal_sse/".concat(this._opt.outType, "?connectionId=").concat(connectionId);
    }

    // Clean up this client's listeners without affecting the shared eventSource
  }, {
    key: "cleanup",
    value: function cleanup() {
      this._abortController.abort();
      this.off('reconnect', this.onReconnect);
    }

    // probably should not use since eventSource is globally shared
  }, {
    key: "destroy",
    value: function destroy() {
      var _eventSource4;
      this.cleanup();
      if (eventSource && ((_eventSource4 = eventSource) === null || _eventSource4 === void 0 ? void 0 : _eventSource4.readyState) !== EventSource.CLOSED) {
        eventSource.close();
        eventSource = undefined;
        connectionId = undefined;
      }
    }
  }]);
}(EventEmitter);